import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "mdn_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
export const clearToken = () => { localStorage.removeItem(TOKEN_KEY); sessionStorage.removeItem(TOKEN_KEY); };

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const dev = localStorage.getItem("ms_wa_device");
  if (dev && window.location.pathname.startsWith("/whatsapp")) config.headers["X-Device-Token"] = dev;
  try {
    const s = JSON.parse(sessionStorage.getItem("ms_secure") || "null");
    if (s?.token) config.headers["X-Secure-Token"] = s.token;
  } catch {
    sessionStorage.removeItem("ms_secure");
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const p = window.location.pathname;
    if (error?.response?.status === 403 && error.response.data?.detail === "secure_required") {
      sessionStorage.removeItem("ms_secure");
      window.dispatchEvent(new Event("secure-change"));
    }
    if (error?.response?.status === 401 && p.startsWith("/whatsapp")) {
      localStorage.removeItem("ms_wa_device");
      window.location.reload();
    }
    if (error?.response?.status === 401 && (p.startsWith("/admin") || p.startsWith("/tecnico"))) {
      clearToken();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export const fileUrl = (id) => `${API}/files/${id}?auth=${localStorage.getItem(TOKEN_KEY) || ""}`;

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Errore imprevisto";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.message === "string") return d.message;
  return String(d);
}

export async function uploadFile(url, file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post(url, fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}
